<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
       :loading="!flagNav"
        transition="scale-transition"
        max-height="64" 
        type="table-heading"
        >
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
            $t("ReportTotalQuestionByUser")
          }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
<v-card class="reportdata-card-main" style="margin-top: 1rem">
      <v-card-title class="d-flex align-center justify-space-between mb-4">
        <div class="d-flex align-center">
          <v-icon color="primary" class="mr-3" size="28">mdi-chart-box-outline</v-icon>
          <h3 class="text-h5 font-weight-bold text-primary">User Usage Report Management</h3>
        </div>
      </v-card-title>
      
      <v-card-text style="padding: 0">
        <!-- Main Filter Row -->
        <v-row class="mb-4">
          <!-- Date Range Section -->
          <v-col cols="12" md="8">
        <div class="reportdata-filter-section">
          <h4 class="reportdata-section-title mb-3">
                <v-icon class="mr-2 ml-3" color="primary" size="20">mdi-calendar-range</v-icon>
                Date Range
              </h4>
              <v-row class="mx-4">
                <v-col cols="5">
              <v-card variant="outlined" class="reportdata-card-outlined">
                    <v-card-text class="pa-3">
                      <v-menu v-model="startDateFlag" :close-on-content-click="false" transition="scale-transition" location="bottom" min-width="auto">
                        <template #activator="{ props }">
                          <v-text-field
                            id="startdate-field-reportuseruse"
                            v-model="startDate"
                            label="Start Date"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            variant="outlined"
                            v-bind="props"
                            density="compact"
                            color="primary"
                  class="reportdata-field-date"
                            clearable
                          >
                            <template #append-inner>
                              <v-tooltip location="top" max-width="200">
                                <template #activator="{ props }">
                                  <v-icon size="small" color="grey-darken-1" v-bind="props">mdi-information-outline</v-icon>
                                </template>
                                <span>Select start date for report</span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker 
                          id="startdate-datapicker-reportuseruse"
                          v-model="startDate" 
                          :max="endDate != null ? endDate : null" 
                          @update:model-value="val => { startDate = formatDate(val); startDateFlag = false }"
                          color="primary"
                        ></v-date-picker>
                      </v-menu>
                    </v-card-text>
                  </v-card>
                </v-col>
                
                <v-col cols="2" class="d-flex align-center justify-center">
                  <v-icon color="grey-darken-2" size="24">mdi-arrow-right</v-icon>
                </v-col>
                
                <v-col cols="5">
              <v-card variant="outlined" class="reportdata-card-outlined">
                    <v-card-text class="pa-3">
                      <v-menu v-model="endDateFlag" :close-on-content-click="false" transition="scale-transition" location="bottom" min-width="auto">
                        <template #activator="{ props }">
                          <v-text-field
                            id="enddate-field-reportuseruse"
                            v-model="endDate"
                            label="End Date"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            variant="outlined"
                            v-bind="props"
                            density="compact"
                            color="primary"
                  class="reportdata-field-date"
                            clearable
                          >
                            <template #append-inner>
                              <v-tooltip location="top" max-width="200">
                                <template #activator="{ props }">
                                  <v-icon size="small" color="grey-darken-1" v-bind="props">mdi-information-outline</v-icon>
                                </template>
                                <span>Select end date for report</span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker 
                          id="enddate-datapicker-reportuseruse"
                          v-model="endDate" 
                          :min="startDate != null ? startDate : null"
                          @update:model-value="val => { endDate = formatDate(val); endDateFlag = false }"
                          color="primary"
                        ></v-date-picker>
                      </v-menu>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-col>

          <!-- Statistics Section -->
          <v-col cols="12" md="4">
        <div class="reportdata-filter-section">
          <h4 class="reportdata-section-title mb-3">
                <v-icon class="mr-2" color="primary" size="20">mdi-chart-box</v-icon>
                Report Statistics
              </h4>
          <v-card variant="outlined" class="reportdata-card-outlined reportdata-card-stats mx-4">
                <v-card-text class="pa-3">
                  <div class="text-center">
                    <v-chip 
                      size="large" 
                      color="info" 
                      variant="elevated"
                      class="px-4"
                    >
                      <v-icon class="mr-2">mdi-account-group</v-icon>
                      {{ dataTable.length }} Users
                    </v-chip>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
        </v-row>

        <!-- Action Buttons Row -->
        <v-row class="mb-4">
          <v-col cols="12">
        <v-card variant="outlined" class="reportdata-card-action">
              <v-card-text class="pa-4">
                <div class="d-flex justify-space-between align-center flex-wrap ga-3 reportdata-flex-responsive">
                  <!-- Left Side - Search Button -->
              <div class="reportdata-action-group">
                    <v-btn 
                      color="primary" 
                      variant="elevated" 
                      size="large" 
                      @click="Search"
                  class="reportdata-btn-search"
                      prepend-icon="mdi-magnify"
                    >
                      Search
                    </v-btn>
                  </div>

                  <!-- Right Side - Download Button -->
              <div class="reportdata-action-group">
                    <v-btn 
                      id="button-download-reportuseruse"
                      color="success" 
                      variant="elevated" 
                      size="large"
                      @click="GetForDownload()"
                  class="reportdata-btn-download"
                      prepend-icon="mdi-download"
                    >
                      Download Report
                    </v-btn>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Data Table with Modern Styling -->
    <v-card class="reportdata-card-table">
      <div class="reportdata-table-container">
       
            <v-data-table-server
              v-model:options="options"
              :items="dataTable"
              :items-per-page="options.itemsPerPage"
              :headers="headers"
              :items-length="totalTable"
              :footer-props="{
                'items-per-page-options': [5, 10, 25, 50, 100],
              }"
          class="reportdata-table-modern"
              density="comfortable"
              hover
              :loading="loadingTable"
            >
              <template #top>
                <v-toolbar flat color="grey-lighten-4" class="table-toolbar">
                  <v-toolbar-title class="text-h6 font-weight-medium">
                    <v-icon class="mr-2" color="primary">mdi-table</v-icon>
                    User Usage Data ({{ totalTable }} records)
                  </v-toolbar-title>
                </v-toolbar>
              </template>
              
              <template #item="{ item }">
            <tr class="reportdata-table-row">
                  <td class="text-center">
                    {{ item.no }}
                  </td>
                  <td>
                <div class="reportdata-text-container">
                      <span 
                        v-for="(subItem, index) in item.title"
                        :key="subItem"
                    class="reportdata-text-standard"
                      >
                        {{ subArray(subItem, index, item.title.length) }}
                      </span>
                    </div>
                  </td>
                  <td class="text-center">
                    {{ substringLong(item.count) }}
                  </td>
                  <td class="text-center">
                    {{ substringLong(item.total_Tokens) }}
                  </td>
                  <td class="text-center">
                    {{ substringLong(item.totalImageGeneration) }}
                  </td>
                  <td class="text-center">
                    {{ substringLong(item.totalCachedTokens) }}
                  </td>
                  <td class="text-center">
                    {{ substringLong(item.totalReasoningTokens) }}
                  </td>
                </tr>
              </template>
            </v-data-table-server>
          </div>
        </v-card>
      </v-card-text>
    </v-card>
    </v-container>

    <v-overlay :model-value="loading" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import dateUtils from '../plugins/date-utils';
import moment from 'moment';
import checkPermissionTwo from '@/api/function.js';
import LogTrace from '@/api/function.js';
export default {
  name: 'ReportUserUse',
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  mixins: [checkPermissionTwo, LogTrace],
  data: () => ({
    today: null,
    loading: false,
    loadingTable: false,
    startDateFlag: false,
    endDateFlag: false,
    startDate: null,
    endDate: null,
    isSearch: false,

    dataTable: [],
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    itemsPerPage: 10,
    totalTable: 0,
    isInitialized: false,
  }),
  computed: {
    headers() {
      return [
        {
          title: this.$t('no'),
          align: 'center',
          width: '8%',
          sortable: false,
        },
        { 
          title: 'User ID', 
          value: 'title', 
          align: 'left', 
          sortable: true,
          width: '25%',
        },
        {
          title: 'Total Questions',
          value: 'count',
          align: 'center',
          sortable: true,
          width: '12%',
        },
        {
          title: 'Total Tokens',
          value: 'total_Tokens',
          align: 'center',
          sortable: true,
          width: '13%',
        },
        {
          title: 'Image Generation',
          value: 'totalImageGeneration',
          align: 'center',
          sortable: true,
          width: '14%',
        },
        {
          title: 'Cached Tokens',
          value: 'totalCachedTokens',
          align: 'center',
          sortable: true,
          width: '14%',
        },
        {
          title: 'Reasoning Tokens',
          value: 'totalReasoningTokens',
          align: 'center',
          sortable: true,
          width: '14%',
        },
      ];
    },
  },
  watch: {
    options() {
      if(!this.isInitialized) return;
      this.GetReport();
    },
  },
  methods: {
    formatDate(dateInput) {
      if (!dateInput) {
        return '';
      }
      if (typeof dateInput === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateInput)) {
        return dateInput;
      }
      
      const d = new Date(dateInput);
      if (isNaN(d.getTime())) {
        return dateInput.toString().substr(0, 10);
      }

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const date = `${year}-${month}-${day}`;
      return date;
    },
    Search() {
      let self = this;
      // self.loading = true;
      self.isSearch = true;
      self.GetReport();
    },
    
    GetReport() {
      let self = this;
      self.loadingTable = true;      
      if(self.startDate != null && self.endDate != null )
      {
        if(self.isSearch){
          self.options.page = 1;
          self.options.itemsPerPage = 10;
        }
        let { page, itemsPerPage, sortBy } = self.options;
        let sortField = null;
        let sortOrder = null;

        if (sortBy && sortBy.length > 0) {
          sortField = sortBy[0].key;
          sortOrder = sortBy[0].order === 'desc';
        }
        let totalPage = self.isSearch ? 10 : self.totalTable;
        let options = {
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : totalPage,
          sortDesc: sortOrder,
          sortBy: sortField
        };

        let temp = {
          StartDate: self.startDate,
          EndDate: self.endDate,
          OptionsDataTable: options, 
        };
        
        self.$call.ReportUserUse(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              if(dataResponse.data.total > 0)
              {
                self.dataTable = dataResponse.data.listData;
                self.totalTable = dataResponse.data.total;
              }
              else
              {
                self.dataTable = [];
              }
            } else {
              self.dataTable = [];
            }
            self.isSearch = false;
            self.loadingTable = false;
          },
          (errorResource) => {
            self.loadingTable = false;
            console.error(errorResource);
          }
        );
      }
      else
      {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: 'Please fill the required fields!!!',
          showConfirmButton: false,
          timer: 1800,
        });
        self.loading = false;
        return;
      }
    },

    async GetForDownload() {
      let self = this;
      self.loading = true;      

      if(self.startDate != null && self.endDate != null )
      {
      let { sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }
        const perPage = 50;
        let options = {
          page: 1,
          perPage: perPage,
          sortDesc: sortOrder,
          sortBy: sortField
        };
        
        let temp = {
          StartDate: self.startDate,
          EndDate: self.endDate,
          OptionsDataTable: options,
        };

        await self.$call.ExportReportUserUse(
          temp,
          async (dataResponse) => {
            if (dataResponse) {
              let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
              let fileLink =  document.createElement('a');

              fileLink.href = fileURL;
              // fileLink.setAttribute('href', fileURL);

              let fileNameShow = `ReportUserUse__${self.convertDateToString(new Date(), '')}.xlsx`;
              fileLink.setAttribute('download', fileNameShow);
              document.body.appendChild(fileLink);

              fileLink.click();
              document.body.removeChild(fileLink);
            }
            self.loading = false;
          },
          async (errorResource) => {
            self.loading = false
            console.error(errorResource);
          }
        );
      }
      else
      {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: 'Please fill the required fields!!!',
          showConfirmButton: false,
          timer: 1800,
        });
        self.loading = false;
        return;
      }
    },

    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },

    async CreateCSVFileDownload(header, array) {
      let self = this;
      let str = '';
      str += header + '\r\n';
      for (const item of array) {
        let line = '';
        line = item.join(',');
        str += line + '\r\n';
      }
      let blob = new Blob([str], { type: 'text/csv;charset=utf-8;' });
      let link = document.createElement('a');
      let url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `ReportUserUse_${self.convertDateToString(new Date(), '')}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    convertDateToString(date, seperator = '/') {
      return dateUtils.getStringWithTimeFromDate(moment(date).toDate(), seperator);
    },
    
    convertDateToString2(date, seperator = '-') {
      return dateUtils.getStringFromDatePickFormatDatePick2(moment(date).toDate(), seperator);
    },
    
    convertDateToString3(date, seperator = '/') {
      return dateUtils.getStringFromDateFormatDatePick(moment(date).toDate(), seperator);
    },

    substringLong(value) {
      if (value == null) {
        return '-';
      }
      if (value.length > 81) {
        return value.substring(0, 80) + '.....';
      }
      return value;
    },

    subArray(value, index, sum) {
      if(index == (sum-1))
      {
        return value;
      }
      else
      {
        return value + ", ";
      }
    },
  },
  mounted() {
    let self = this;
    self.GetDate();
    var date = new Date();
    self.endDate = self.convertDateToString2(date);
    self.startDate = self.convertDateToString2(date);
    self.GetReport();
    this.isInitialized = true;
  },
};
</script>

<style scoped>

</style>
